import React, { useState } from 'react';
import { useStore } from '../../utils/score';
import { useStoreAnswered } from '../../utils/answeredQuestions'
import { useHistory } from "react-router-dom";
import correctSound from '../../audio/correct.mp3';
import wrongSound from '../../audio/incorrect.mp3';
import { Fragment } from 'react';




const Otazka = ({ data, cardIndex }) => {
    
    
    const {pridajZlatoScore, pridajKremikScore, odoberZlatoScore, odoberKremikScore,  setVideoUrl, settextOdpoved} = useStore();
    const {addUseStoreAnswered} = useStoreAnswered();
    const [result, setResult] = useState();
    const [points, togglePoints] = useState(false);
    let history = useHistory();

    console.log(points)

  //


     const handleAnswerOptionClick = (isCorrect, team, videourl, textOdpoved) => {
		if (isCorrect) {
            team === "zlato" ? pridajZlatoScore(points) : pridajKremikScore(points)
            setResult("Correct");
            addUseStoreAnswered();
            setVideoUrl(videourl);
            settextOdpoved(textOdpoved);
            const element = document.querySelector('.otazka');
                element.classList.add('animate__animated', 'animate__fadeOut');
            const result = document.querySelector('.result');
                result.classList.add('animate__animated', 'animate__zoomIn', 'result-visible');
                document.getElementById('correctSound').play();
            const resultColor = document.querySelector('.result-color');
                resultColor.classList.add('result-green');
            setTimeout(() => { history.push("/play/video"); }, 2000);

            
            
        } else {
            team === "zlato" ? odoberZlatoScore(points) : odoberKremikScore(points)
            addUseStoreAnswered();
            setResult("Incorrect")
            setVideoUrl(videourl)
            settextOdpoved(textOdpoved);
            const element = document.querySelector('.otazka');
                element.classList.add('animate__animated', 'animate__fadeOut');
            const result = document.querySelector('.result');
                result.classList.add('animate__animated', 'animate__zoomIn', 'result-visible');
                document.getElementById('wrongSound').play();

            const resultColor = document.querySelector('.result-color');
                resultColor.classList.add('result-red');
            document.getElementById('wrongSound').play();
            setTimeout(() => { history.push("/play/video"); }, 2000);
            setTimeout(() => { history.push("/play/video"); }, 2000);
            
            
            
        }
	};
 
    return (
        <div>
            <Fragment>
                <audio id='correctSound' src={correctSound}></audio>
                <audio id='wrongSound' src={wrongSound}></audio>
            </Fragment>
            <center>
            <div className="result-quiz"> 
                <p className="result" ><span className="result-color">{result}</span>!</p>
            </div> 
            </center>

            <div className="otazka animate__animated animate__fadeIn ">
                {data[cardIndex].map((item, index) => (
                    
                    <div key={index}>
                        {points && (
                <div>
                <div className="quesiton-container"> 
                            <h1>{item.title}</h1>
                            <p>{item.otazka}</p>
                            {/* <img src={require({item.obrazok})} width='200' height='200'></img> */}
                            <img src={item.obrazok} alt=""></img>
                        
                        </div> 
                        <div className='btn-container'>
                                {item.answerOptions && item.answerOptions.map((answerOption) => (
                                    <button className="btn btn-yes" onClick={() => handleAnswerOptionClick(answerOption.isCorrect,item.team,item.videourl,item.textOdpoved)}>{answerOption.answerText}</button>
                                ))}	
                        </div>
</div>
                        )
                                }
                                
{!points && (
                        <div>
                        <div className="quesiton-container">
                        <h1>Value for question:</h1>
                        <p>{item.title}</p>
                        </div>
                        
                        <div className='btn-container'>
                        
                        <button className="btn btn-yes" onClick={() => togglePoints(100)}>100</button>
                        <button className="btn btn-yes" onClick={() => togglePoints(300)}>300</button>
                        <button className="btn btn-yes" onClick={() => togglePoints(500)}>500</button>
   
                        </div>
                        </div>
)
}

                        
                        

                    </div>
                ))}
            </div>

            


         </div>
   
    );
};


export default Otazka;